"use client";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { debounce } from "@/ui/hooks/use-debounced-value";
import { Label } from "@/ui/shadcn/label";
import { StatefulInput } from "@/ui/stateful-input";
import type { YnsDataType } from "../types";
import type { Breadcrumbs } from "./breadcrumbs";

export const BreadcrumbsForm = ({ data }: { data: YnsDataType<typeof Breadcrumbs> }) => {
	const context = useStoreBuilderContext<typeof Breadcrumbs>();

	return (
		<div className="grid gap-4 relative pb-20">
			<Label className="grid gap-2 mt-2">
				<span>First element in breadcrumbs</span>
				<StatefulInput
					required
					defaultValue={data.title}
					onValueChange={debounce(
						(value) => {
							context.saveSelectedPageSectionField({
								fieldPath: "title",
								value,
							});
						},
						300,
						{ trailing: true },
					)}
				/>
			</Label>

			<Label className="grid gap-2 mt-2">
				<span>Fallback title for static pages</span>
				<StatefulInput
					defaultValue={data.pageTitle}
					onValueChange={debounce(
						(value) => {
							context.saveSelectedPageSectionField({
								fieldPath: "pageTitle",
								value,
							});
						},
						300,
						{ trailing: true },
					)}
				/>
			</Label>
		</div>
	);
};
